<template>
  <div class="container">
    <div class="row">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "component-container",
};
</script>
